import { render, staticRenderFns } from "./detailProgress.vue?vue&type=template&id=6586720d&scoped=true"
import script from "./detailProgress.vue?vue&type=script&lang=js"
export * from "./detailProgress.vue?vue&type=script&lang=js"
import style0 from "./detailProgress.vue?vue&type=style&index=0&id=6586720d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586720d",
  null
  
)

export default component.exports